import { get } from 'lodash';
import { useQuery } from 'react-query';

import { handleApiErrors } from '../../api/axiosInstance';
import { RATES_API } from '../../api/rates';
import useTablePagination from '../useTablePagination';
import useTableSort from '../useTableSort';

/**
 * @param {string} rateId
 * @param {string} rateType
 * @param {string?} searchTerm
 * @param {import('react-query').UseQueryOptions?} otherOptions
 */
const useUsersInRateQuery = (rateId, rateType, searchTerm, otherOptions = {}) => {
  const {
    paginationConfig,
    handlePageChange,
    handlePageSizeChange,
    handleTotalUpdate,
  } = useTablePagination();

  const { stringTableSort, handleTableSort } = useTableSort({ firstName: 1, lastName: 1 });

  const usersInRateQuery = useQuery({
    ...otherOptions,
    enabled: typeof rateType !== 'undefined' && get(otherOptions, 'enabled', true),
    placeholderData: { documents: [], totalCount: 0 },
    initialData: { documents: [], totalCount: 0 },
    queryKey: [
      rateId,
      rateType,
      searchTerm,
      stringTableSort,
      paginationConfig.current,
      paginationConfig.pageSize,
    ],
    queryFn: () => {
      if (rateType && rateId) {
        return RATES_API.fetchUsersAssociatedToRate(
          rateId,
          { searchTerm, sort: stringTableSort },
          paginationConfig.current,
          paginationConfig.pageSize,
        );
      } else {
        return { documents: [], totalCount: 0 };
      }
    },
    onSuccess: ({ totalCount, documents }) => {
      handleTotalUpdate(totalCount);
      if (otherOptions.onSuccess) otherOptions.onSuccess({ totalCount, documents });
    },
    onError: error => {
      handleApiErrors(error.response);
    },
  });

  return {
    paginationConfig,
    handlePageChange,
    handlePageSizeChange,
    usersInRateQuery,
    handleTableSort,
  };
};

export default useUsersInRateQuery;
